import { Mutation, Action } from 'vuex-module-decorators';
import { Resolve } from 'vue-di';
import { InjectModule, InjectVuexModule } from 'vue-di/vuex';
import { EdgeCouponApi, ApigatewayApi , EdgeEnrollmentApi, EscoordV1Api } from '@trialcard/apigateway.client';
import {
    EnrollmentInsuranceVerificationModel,
    EnrollmentSurveyQuestionModel,
    EnrollmentDemographicsModel,
    EnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel,
    UpsearchModelEnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel,
    EnterpriseCoordinatorSharedEmailAddressUpsearchModel,
    EnterpriseCoordinatorSharedAddressUpsearchModel,
    EnterpriseCoordinatorSharedPhoneUpsearchModel,
    EnterpriseCoordinatorAccountServiceModelsAccountContactUpsearchModel,
    UpsearchModelEnterpriseCoordinatorAccountServiceModelsAccountUpsearchModel,
    EnterpriseCoordinatorAccountUpsearchRequestModel,
    EnrollPatientRequestModel,
    EnterpriseCoordinatorAccountServiceModelsAccountContactPreferenceModel,
    EnterpriseCoordinatorPrescriberServiceModelsPrescriberUpsearchModel,
    EnterpriseCoordinatorAccountServiceModelsAccountExternalIdModel,
    UpsearchModelEnterpriseCoordinatorPrescriberServiceModelsPrescriberUpsearchModel,
    UpsearchModelEnterpriseCoordinatorSiteServiceModelsSiteUpsearchModel,
    UpsearchModelEnterpriseCoordinatorPayorServiceModelsPayorUpsearchModel,
    EnrollPatientCaseInitiator,
} from '@trialcard/apigateway.models';
import { EdgePatientEnrollmentApi } from '@trialcard/apigateway.client/edgePatientEnrollmentApi';
import moment, { Moment } from 'moment';
import { Gender , RoleType , AccountExternalIdType} from '@trialcard/enums';
import * as enums from '@trialcard/enums';
import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import EligibilityModule from './eligibility';
import { CouponPatient, PatientInsurance } from './interfaces';
import DocusignModule from './docusign';
import { clearRecords } from '~/services/clearRecords';
import { ProgramState, ProgramVariables } from '~/types/types';
import SurveyModule from '~/store/survey';
import { Settings } from '~/services/settings';
import { Field } from '~/types/docuSign/Fields';
import  CommonTools  from '~/components/tools/commonTools';

@InjectModule({ stateFactory: true }, module)
export default class EnrollmentModule extends InjectVuexModule {
    @Resolve
    patientEnrollmentApi!: EdgePatientEnrollmentApi;

    @Resolve
    enrollmentApi!: EdgeCouponApi;
    @Resolve
    eligibility!: EligibilityModule;
    @Resolve
    apiGateWay!: ApigatewayApi;

    @Resolve
    public settings!: Settings;

    programId: number | null = null;

    @Resolve
    survey!: SurveyModule;

    @Resolve
    public escoord!: EscoordV1Api;

    @Resolve
    docusign!: DocusignModule;

    programState: ProgramState = ProgramState.Gilead;

    selectedUserIdentity = '' as string;

    pharmacyName = '' as string;

    validMemberNumber = -1;

    memberNumber = '';
    memberNumberMedical = '';
    memberNumberPharmacy = '';
    // CENTRAL SUBMISSION GUARD FLAG
    isEnrollmentInProgress = false;

    defaultAlternateId = [
        {
            externalIdType: AccountExternalIdType.THIRDPARTYID,
            externalId: '',
        },
    ] as EnterpriseCoordinatorAccountServiceModelsAccountExternalIdModel[];

    alternateIds = [...this.defaultAlternateId];

    defaultPrescriberData = [
        {
            model: {
                firstName: '',
                lastName: '',
                npi: '',
                accountRelationshipIsPrimary: true,
                prescriberLicenses: [],
                externalIds: [],
                addresses: [],
                phoneNumbers: [],
                emailAddresses: [],
            },
        },
    ] as any;

    prescriberData = [...this.defaultPrescriberData];

    defaultPrescriberCheckboxData = {
        checkBox : false as boolean,
        checkboxText : ''
    }
    prescriberCheckboxData = {...this.defaultPrescriberCheckboxData}

    enrollmentInformation = {
        memberNumber: '',
        bin: '',
        pcn: '',
        groupNumber: '',
    };

    accountId = (null as unknown) as number;
    structureCreateEnvelopeRequest(accountId:number) {
        const {
            dateOfBirth,
            emailAddresses,
            phoneNumbers,
        } = this.patientInformationData

        const firstName = CommonTools.titleCase(this.patientInformationData.firstName || '');
        const lastName = CommonTools.titleCase(this.patientInformationData.lastName || '');
        const patEmail = emailAddresses.length > 0 && emailAddresses[0].address || '';
        const patGender = this.patientInformationData.gender || '';

        const phone = phoneNumbers.length > 0 && phoneNumbers[0].phoneNumber || '';
        const patName = CommonTools.titleCase(`${firstName} ${lastName}`);
        const pat_address  = this.patientInformationData.addresses.length > 0 && this.patientInformationData.addresses[0].addressOne || '';
        const zipCode = this.patientInformationData.addresses.length > 0 && this.patientInformationData.addresses[0].zip || '';
        const state = this.patientInformationData.addresses.length > 0 && this.patientInformationData.addresses[0].state || '';
        const city = this.patientInformationData.addresses.length > 0 && this.patientInformationData.addresses[0].city || '';

        const prescriberFirstName = this.prescriberData[0].model?.firstName || '';
        const prescriberLastName = this.prescriberData[0].model?.lastName || '';
        const prescriberFullName = `${prescriberFirstName} ${prescriberLastName}`;
        const prescriberPhone = this.prescriberData.length > 0 && this.prescriberData[0].model?.phoneNumbers[0].phoneNumber || '';
        const prescriberAddress = this.siteData.length > 0 && this.siteData[0].model?.addresses[0].addressOne || '';
        const prescriberZip = this.siteData.length > 0 && this.siteData[0].model?.addresses[0].zip || '';
        const prescriberState = this.siteData.length > 0 && this.siteData[0].model?.addresses[0].state || '';
        const prescriberCity = this.siteData.length > 0 && this.siteData[0].model?.addresses[0].city || '';
        const prescriberCheckboxText = this.prescriberCheckboxData.checkboxText || '';
        const request = {
            accountId,
            programId: +this.settings.programId,
            documentType: 'SRF', // Hard coded for now based on documentation from Team Code Brigade
            brandId: this.docusign.selectBrandId(),
            senderId: this.settings.senderId,
            templateId:  this.docusign.selectTemplate(),
            replyEmailAddressOverride: 'no-reply@docusign.net',
            expireInDays: +this.settings.expireInDays,
            emailSubject: ' ',
            emailBody: ' ',
            send: true, // Send needs to be set to true to request a RecipientView.
            embedded: true, // Embedded needs to be set to true for envelope intended for RecipientView
            recipients: [
                {
                    name:  patName,
                    email:  patEmail,
                    role:"Patient",
                }
            ],
            fields: [
                {
                    name: 'Pat_Full_Name',
                    value: patName
                },
                {
                    name: 'Pat_First',
                    value : firstName
                },
                {
                    name:'Pat_Last',
                    value : lastName
                },
                {
                    name:'Pat_Gender',
                    value : patGender == 1? 'Male' : 'Female'
                },
                {
                    name:'Pat_DOB',
                    value : moment(dateOfBirth).format('L')
                },
                {
                    name:'Pat_Email',
                    value : patEmail
                },
                {
                    name:'Pat_Mobile_Ph',
                    value : phone
                },
                {
                    name:'Pat_Address1',
                    value : pat_address
                },
                {
                    name:'Pat_ZIP',
                    value : zipCode
                },
                {
                    name:'Pat_City',
                    value : city
                },
                {
                    name:'Pat_State',
                    value : state
                },
                {
                    name:'MD_Name',
                    value : prescriberFullName
                },
                {
                    name:'MD_Phone',
                    value : prescriberPhone
                },
                {
                    name:'MD_Address1',
                    value : prescriberAddress
                },
                {
                    name:'MD_City',
                    value : prescriberCity
                },
                {
                    name:'MD_State',
                    value : prescriberState
                },
                {
                    name:'MD_ZIP',
                    value : prescriberZip
                },
                {
                    name:'Rx_Sent',
                    value: !!this.prescriberCheckboxData.checkBox === true? 'true' : 'false'
                },
                {
                    name:'Pharmacy',
                    value : prescriberCheckboxText
                },
            ] as Field[]
        };
        return request;
    }

    getProgramVariables() {
        return ProgramVariables.find(item => item.ProgramState === this.programState);
    }

    @Mutation
    updateAlternateIdLC(newAlternateId: typeof EnrollmentModule.prototype.alternateIds) {
        this.alternateIds = [...newAlternateId];
    }
    @Mutation
    setProgramState(value: ProgramState) {
        this.programState = value;
    }

    @Mutation
    setMemberNumber(value: string) {
        this.memberNumber = value;
    }

    @Mutation
    updatePatientInformation(data: typeof EnrollmentModule.prototype.defaultPatientInformationData) {
        Object.assign(this.patientInformationData, data);
    }

    @Mutation
    updatePrescriberCheckboxData(data: typeof EnrollmentModule.prototype.defaultPrescriberCheckboxData) {
        Object.assign(this.prescriberCheckboxData, data);
    }

    @Mutation
    public async updatePresriberData(newPresriberInformation: typeof EnrollmentModule.prototype.defaultPrescriberData) {
        this.prescriberData = [...newPresriberInformation];
    }

    @Mutation
    UpdatepharmacyName(Name: string) {
        this.pharmacyName = Name;
    }

    @Mutation
    updateInsuranceInformation(data: typeof EnrollmentModule.prototype.payorInformationDataLC) {
        Object.assign(this.payorInformationDataLC, data);
    }

    @Mutation
    public async updateContactPreferences(newContactPreferences: EnterpriseCoordinatorAccountServiceModelsAccountContactPreferenceModel[]) {
        this.contactPreferencesLC = [...newContactPreferences];
    }

    @Mutation
    updateEnrollmentInformation(data: typeof EnrollmentModule.prototype.enrollmentInformation) {
        Object.assign(this.enrollmentInformation, data);
    }

    @Mutation
    UpdateSelectedUserIdentity(selectedUserIdentity: string) {
        this.selectedUserIdentity = selectedUserIdentity;
    }

    @Mutation
    clearPatientInformation() {
        clearRecords(this.patientInformationData);
    }
    @Mutation
    clearInsuranceInformation() {
        clearRecords(this.payorInformationDataLC);
    }
    @Mutation
    clearPrescriberInformation() {
        clearRecords(this.prescriberData);
    }

    @Mutation
    clearEnrollmentInformation() {
        clearRecords(this.enrollmentInformation);
        this.memberNumberMedical = '';
        this.memberNumberPharmacy = '';
    }

    // @Mutation
    @Action({ rawError: true })
    clearAll() {
        // this.eligibility.clear();
        this.clearPatientInformation();
        this.clearInsuranceInformation();
        this.clearPrescriberInformation();
        this.updateSites(this.defaultSiteData);
        this.updatePresriberData(this.defaultPrescriberData);
        this.updateContactPreferences(this.defaultContactPreferences);
        this.updateAlternateIdLC(this.defaultAlternateId);
        this.clearEnrollmentInformation();
        this.UpdatepharmacyName('');
    }


    @Mutation
    setMemberNumberMedicalLC(value: string) {
        this.memberNumberMedical = value;
    }

    @Mutation
    setMemberNumberPharmacyLC(value: string) {
        this.memberNumberPharmacy = value;
    }

    @Mutation
    setEnrollmentInProgress(value: boolean) {
        this.isEnrollmentInProgress = value;
    }

    get enrollmentInProgress() {
        return this.isEnrollmentInProgress;
    }

    defaultPatientInformationData = {
        firstName: '' as string,
        lastName: '' as string,
        dateOfBirth: null as Moment | null,
        addresses: [] as EnterpriseCoordinatorSharedAddressUpsearchModel[],
        emailAddresses: [] as EnterpriseCoordinatorSharedEmailAddressUpsearchModel[],
        phoneNumbers: [] as EnterpriseCoordinatorSharedPhoneUpsearchModel[],
        gender: null as enums.Gender | null,
        // thirdPartyId: '' as string
    };

    patientInformationData = { ...this.defaultPatientInformationData };

    defaultSiteData = [
        {
            canUpdate: true,
            canInsert: true,
            skipSearch: false,
            model: {
                accountRelationshipIsPrimary: true,
                siteRoleType: RoleType.PrescriberSite,
                pointOfContacts: [],
                description: '',
                addresses: [
                    {
                        addressOne: '',
                        addressTwo: '',
                        zip: '',
                        city: '',
                        state: '',
                    },
                ],
                contacts: [],
                emailAddresses: [],
                externalIds: [],
                phoneNumbers: [
                    {
                        phoneType: 1,
                        phoneNumber: '',
                        phonePurpose: 5,
                    },
                    {
                        phoneType: 3,
                        phoneNumber: '',
                        phonePurpose: 8,
                    },
                ],

                globalIds: [],
            },
        },
    ] as any;

    siteData = [...this.defaultSiteData];

    alternativeEnrollment: boolean | null = null;
    medicalMemberNumber: string | null = null;
    pharmacyMemberNumber: string | null = null;
    expirationDate: Moment | null = null;

    @Mutation
    setExpirationDate(expirationDate: Moment) {
        this.expirationDate = expirationDate;
    }


    @Mutation
    public async updateSiteData(newSiteData: typeof EnrollmentModule.prototype.defaultSiteData) {
        this.siteData = [...newSiteData];
    }

    @Mutation
    setMedicalMemberNumber(memberNumber: string | null) {
        this.medicalMemberNumber = memberNumber;
    }

    @Mutation
    setPharmacyMemberNumber(memberNumber: string | null) {
        this.pharmacyMemberNumber = memberNumber;
    }

    defaultContactPreferences = [] as EnterpriseCoordinatorAccountServiceModelsAccountContactPreferenceModel[];
    contactPreferencesLC = [...this.defaultContactPreferences];
    selectedPrescriber = {} as EnterpriseCoordinatorPrescriberServiceModelsPrescriberUpsearchModel | null;

    defaultPayorObject = {
        model: {
            payorId: (null as unknown) as number,
            payorType: (null as unknown) as number,
            accountRelationshipIsPrimary: true,
            payorGroup: '',
            payorName: '',
            webAddresses: [],
            addresses: [],
            phoneNumbers: [
                {
                    phoneType: 1,
                    phoneNumber: '',
                    phonePurpose: 1,
                },
                {
                    phoneType: 3,
                    phoneNumber: '',
                    phonePurpose: 8,
                },
            ],
            emailAddresses: [],
            contacts: [],
            payorBenefit: {
                policyNumber: '',
            },
        },
    };

    defaultPayorData = [
        { ...this.defaultPayorObject },
        { ...this.defaultPayorObject },
    ] as UpsearchModelEnterpriseCoordinatorPayorServiceModelsPayorUpsearchModel[];

    payorInformationDataLC = [...this.defaultPayorData];

    @Mutation
    updateInsuranceInformationLC(data: typeof EnrollmentModule.prototype.payorInformationDataLC) {
        this.payorInformationDataLC = [...data];
    }

    @Mutation
    public async updateSites(newSites: UpsearchModelEnterpriseCoordinatorSiteServiceModelsSiteUpsearchModel[]) {
        this.siteData = [...newSites];
    }

    @Mutation
    public async updateAccountId(accountId: any) {
        this.accountId =  accountId;
    }
    structureRecipientViewUrlRequest(accountId:number) {
        const {
            emailAddresses
        } = this.patientInformationData
        const firstName = CommonTools.titleCase(this.patientInformationData.firstName || '');
        const lastName = CommonTools.titleCase(this.patientInformationData.lastName || '');
        const patName = CommonTools.titleCase(`${firstName} ${lastName}`);
        const patEmail = emailAddresses.length > 0 && emailAddresses[0].address || '';
        const request = {
            programId: +this.settings.programId,
            accountId,
            envelopeId: this.docusign.envelopeId,
            email:patEmail,
            name:patName,
            returnUrl: `${CommonTools.getBaseUrl(window.location.href, this.settings)}enroll-complete`,
        };
        return request;
    }

    getCaseInitiator() {
        const caseInitiatorMap = {
            Patient: EnrollPatientCaseInitiator.patient,
            HCP: EnrollPatientCaseInitiator.provider,
            'Specialty Pharmacy': EnrollPatientCaseInitiator.pharmacy,
        };
        const initiator = this.eligibility.eligibilityData.find(answer =>
            ['Patient', 'HCP', 'Specialty Pharmacy'].includes(answer.answerValue || '')
        );
        if (!initiator) {
            return '';
        }
        const caseInitiator = caseInitiatorMap[initiator.answerValue as 'Patient' | 'HCP' | 'Specialty Pharmacy'];
        return caseInitiator;
    }

    @Action({ rawError: true })
	public clearStore() {
         this.eligibility.clearStore();
        this.clearPatientInformation();
        this.clearInsuranceInformation();
        this.updateSites(this.defaultSiteData);
        this.updatePresriberData(this.defaultPrescriberData);
        this.updateContactPreferences(this.defaultContactPreferences);
        this.updateAlternateIdLC(this.defaultAlternateId);
        this.UpdatepharmacyName('');
        this.updateSiteData(this.defaultSiteData);
        this.updatePrescriberCheckboxData(this.defaultPrescriberCheckboxData);
    }

    @Action({ rawError: true })
    async submitToAPI(enrollCall = false) {
            // Check if already submitting
        if (this.isEnrollmentInProgress) {
            return null; // Prevent duplicate API submissions
        }

         this.setEnrollmentInProgress(true);// Lock submission
        let response = null;
        let responseAccount = null;
        try {
            const caseInitiator = this.getCaseInitiator();
            if (!caseInitiator) {
                throw new Error('Case Initiator not found');
            }

            const patientForAccountUpsearch = {
                account: {
                    sourceId: +this.settings.caseSource,
                    patientData: {
                        canUpdate: true,
                        canInsert: true,
                        skipSearch: false,
                        model: {
                            suffix: '',
                            nickname: '',
                            middleName: '',

                            ...this.patientInformationData,
                        } as EnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel,
                    } as UpsearchModelEnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel,
                    accountData: {
                        canUpdate: true,
                        canInsert: true,
                        skipSearch: false,
                        model: {
                            accountType: 1,
                            accountStatus: 1,
                            contactPreferences: this.contactPreferencesLC,
                        },
                    } as UpsearchModelEnterpriseCoordinatorAccountServiceModelsAccountUpsearchModel,
                    surveySessionData: [this.survey.sessionId] as number[],
                } as EnterpriseCoordinatorAccountUpsearchRequestModel,
                caseInitiator,
            } as any;

            const patient = {
                account: {
                    sourceId: +this.settings.caseSource,
                    patientData: {
                        canUpdate: true,
                        canInsert: true,
                        skipSearch: false,
                        model: {
                            suffix: '',
                            nickname: '',
                            middleName: '',

                            ...this.patientInformationData,
                        } as EnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel,
                    } as UpsearchModelEnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel,
                    accountData: {
                        canUpdate: true,
                        canInsert: true,
                        skipSearch: false,
                        model: {
                            accountType: 1,
                            accountStatus: 1,
                            contactPreferences: this.contactPreferencesLC,
                        },
                    } as UpsearchModelEnterpriseCoordinatorAccountServiceModelsAccountUpsearchModel,
                    prescriberData: this.prescriberData,
                    siteData: this.siteData,
                    surveySessionData: [this.survey.sessionId] as number[],
                } as EnterpriseCoordinatorAccountUpsearchRequestModel,
                caseInitiator,
            } as any;
             if(!enrollCall){
                responseAccount = await this.escoord.accountUpsearchByTenantIdProgramId( patientForAccountUpsearch.account, +this.settings.programId!);
                const tempAccountID = (responseAccount.data && responseAccount.data.data && responseAccount.data.data.accountId ) || ''
                const createEnvelopeSuccess = await this.docusign.createEnvelope(this.structureCreateEnvelopeRequest(+tempAccountID));
                const requestUrlSuccess = createEnvelopeSuccess && await this.docusign.requestURL(this.structureRecipientViewUrlRequest(+tempAccountID)) || null;
                this.updateAccountId(tempAccountID);
                return true;
            }
            else{
                response = await this.patientEnrollmentApi.patientEnrollmentEnrollPatient(patient, this.settings.programId);
            }
            } catch (error) {
            // Handle error
                response = { status: 400 } as AxiosResponse;
            } finally {
                 this.setEnrollmentInProgress(false);// Always unlock after attempt
            }
            return response;
    }

    determineProgramId(userIdentityAnswerId: number) {
        const ProgVariable = ProgramVariables.find(item => item.ProgramState === this.programState) || ({} as any);

        switch (userIdentityAnswerId) {
            case ProgVariable.Survey.userIdentityAnswer.patientAnswerId: {
                return ProgVariable.PatientProgramId;
            }
            case ProgVariable.Survey.userIdentityAnswer.patientRepAnswerId: {
                return ProgVariable.PatientRepProgramId;
            }
            case ProgVariable.Survey.userIdentityAnswer.hcpAnswerId: {
                return ProgVariable.HcpProgramId;
            }
            case ProgVariable.Survey.userIdentityAnswer.pharmacyAnswerId: {
                return ProgVariable.PharmacyProgramId;
            }
            default: {
                return ProgVariable.PatientProgramId;
            }
        }
    }
}
